import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import svgImages from "../Assets/Images/svgImages";
import { useTranslation } from "react-i18next";

const { BritainSvg, GernamySvg } = svgImages;

const FlagWrapper = ({ children }) => (
  <div
    style={{
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {children}
  </div>
);

const flags = {
  en: () => (
    <FlagWrapper>
      <BritainSvg />
    </FlagWrapper>
  ),
  de: () => (
    <FlagWrapper>
      <GernamySvg />
    </FlagWrapper>
  ),
};

const languages = [
  { code: "de", label: "German", icon: flags.de },
  { code: "en", label: "English", icon: flags.en },
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  // ✅ Sync initial language with i18n
  const currentLang =
    languages.find((l) => l.code === i18n.language) || languages[1];

  const [lang, setLang] = useState(currentLang);
  const [open, setOpen] = useState(false);

  const changeLang = (langObj) => {
    setLang(langObj);
    i18n.changeLanguage(langObj.code);
    setOpen(false);
  };

  const CurrentIcon = lang.icon;

  return (
    <div className="lang-selector">
      <button
        className="lang-pill"
        onClick={() => setOpen((prev) => !prev)}
        type="button"
      >
        <div className="flag">
          <CurrentIcon />
        </div>
        {lang.label}
        <KeyboardArrowDownIcon className="lang-arrow" />
      </button>

      {open && (
        <div className="lang-dropdown">
          {languages
            .filter((l) => l.code !== lang.code)
            .map((l) => {
              const Icon = l.icon;
              return (
                <div
                  key={l.code}
                  className="lang-option"
                  onClick={() => changeLang(l)}
                >
                  <div className="flag">
                    <Icon />
                  </div>
                  {l.label}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}
